module.exports = __webpack_public_path__ + "static/media/sailing-yacht.a6521858.svg";